/**
 * Created by mykurisu on 2017/9/21.
 */
import React from 'react'
import {ActionSheet, Badge} from 'react-weui'
import {WKSquareButton} from './index'
import {browserHistory} from 'react-router'
import '../../css/wkCommon.css'
import operationBtn from '../../images/liveroom/operation@3x.png'

class WKOperation extends React.Component {

    constructor() {
        super();
        this.state = {
            sheetShow: false,
            isOpenOtherActionsheet:false,
            sheetActions: [
                {
                    label: '取消',
                    onClick: this.handleSheetHide.bind(this),
                    className:'liveroom-actionsheet'
                }
            ],
            secondActionSheetMenu:[
                {
                    className:'lizhiweike-secendAs',
                    label: '直播间基本信息',
                    onClick: ()=> {
                        location.assign(`/liveroom/${this.props.liveroomId}/edit/profile`)
                    }
                }, {
                    className:'lizhiweike-secendAs',
                    label: '设置管理员',
                    onClick: ()=> {
                        location.assign(`/liveroom/${this.props.liveroomId}/edit/manage`)
                    }
                }, {
                    className:'lizhiweike-secendAs',
                    label: '管理黑名单',
                    onClick: () => {
                        location.assign(`/liveroom/${this.props.liveroomId}/edit/ban`)
                    }},
            ],
            cancelcallback: [
                {
                    className:'lizhiweike-secendAs-cancel',
                    label: '取消',
                    onClick: this.cancelSecondActionsheet.bind(this)
                }
            ]
        }
    }


    componentWillReceiveProps(props){
        if(props.openOtherActionSheet){
            this.setState({
                isOpenOtherActionsheet:true,
            })
        }
    }

    cancelSecondActionsheet(){
        this.setState({
            isOpenOtherActionsheet:false
        })
    }

    handleSheetHide() {
        this.setState({
            sheetShow: false
        })
    }

    renderSheetMenus() {
        return (
            <div className="operation-sheet">
                {this.props.editList.map((item, index) =>
                    <WKSquareButton nopic={item.nopic} blockContent={item.blockContent} hasContent={item.hasContent} key={index} handleSheetHide={() => this.handleSheetHide()}/>)
                }
            </div>
        )
    }

    render() {
        return (
            <div className="operation">
                <ActionSheet
                    menus={[{label: this.renderSheetMenus()}]}
                    actions={this.state.sheetActions}
                    show={this.state.sheetShow}
                    type="ios"
                    onRequestClose={e=>this.setState({sheetShow: false})}
                />

                <ActionSheet
                    menus={this.state.secondActionSheetMenu}
                    actions={this.state.cancelcallback}
                    show={this.state.isOpenOtherActionsheet}
                    type="ios"
                    onRequestClose={e=>this.setState({
                        isOpenOtherActionsheet:false
                    })}
                />


                    <div className="lecture-operating-entry">
                        {this.props.liveroomId ?
                            <div className="lecture-operating-entry_icon lecture-operating-entry_icon_primary"
                                 onClick={() => this.setState({sheetShow: true})}>
                                <img src={operationBtn} alt="" style={{width: '22px'}}/>
                                {this.props.isNew &&
                                <Badge className="msg-dot" dot preset="header"/>
                                }
                            </div>
                            :
                            <div className="lecture-operating-entry_icon" onClick={() => this.setState({sheetShow: true})}>
                                <i className="icon iconfont icon-mokuai" style={{fontSize: '22px'}}/>
                                <div>操作</div>
                            </div>
                        }
                    </div>
            </div>
        )
    }
}

export default WKOperation



// WEBPACK FOOTER //
// ./src/components/wk/WKOperation.js